import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import { Nullable } from "primereact/ts-helpers";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";

import dayjs from "dayjs";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import moment from "moment";

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
// import Loader from "../../../core/common/loader";
import Loader from "../../../core/common/custom-loading/Loading";
import Loadingbtn from "../../../Loader";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const LeadsDasboard = () => {
  const routes = all_routes;
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const [date, setDate] = useState<Nullable<Date>>(null);

  const [totalLead, setTotalLead] = useState<any>([]);
  // console.log("totallead data", totalLead)
  const [pipeLine, setPipeLine] = useState<any>([]);
  const [selectedFilter, setSelectedFilter] = useState("Select");
  const [lostLeadReason, setLostLeadReason] = useState<any>([]);
  // const [lostLeadReason, setLostLeadReason] = useState<any>([]);
  const [series, setSeries] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const [charRevenue, setChartRevenue] = useState([]);
  const [income, setIncome] = useState<any>([]);
  const [monthValue, setMonthValue] = useState<any>([]);

  const [chartOptions, setChartOptions] = useState<any>({
    chart: {
      height: 355,
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },
    colors: ["#014d4e", "#F8F9FA"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 5,
        borderRadiusWhenStacked: "all",
        horizontal: false,
        endingShape: "rounded",
        columnWidth: "35%",
      },
    },
    xaxis: {
      categories: [], // to be set dynamically
      labels: {
        // offsetX: -10,
        style: {
          colors: "#6B7280",
          fontSize: "9px",
        },
      },
      tickPlacement: "betweeen",
    },
    yaxis: {
      labels: {
        offsetX: -15,
        style: {
          colors: "#6B7280",
          fontSize: "10px",
        },
      },
    },
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
      padding: {
        top: 0, // Add some top padding
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    legend: { show: false },
    dataLabels: { enabled: false },
    fill: { opacity: 1 },
  });

  // for chart data

  // Utility to map dropdown label to API expected value
  const filterKeyMap: Record<any, any> = {
    "This Month": "this_month",
    "This Week": "this_week",
    "Last Week": "last_week",
  };

  const getLostLeadReason = async (filter: string) => {
    try {
      setLoading(true);
      const payload = { filter };
      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.LOST_LEAD_REASON,
        payload,
      );

      const apiData = response?.data || [];
      // console.log(apiData);

      setLostLeadReason(apiData);

      // Extract x-axis and data
      const categories = apiData.map((item: any) => item.description);
      const data = apiData.map((item: any) => item.total);
      const expenses = apiData.map((item: any) => {
        // Example logic: 1 expense = total * 10
        return item.total * 10;
      });
      const totals = apiData.map((item: any) => item.total);
      // console.log("totals", totals);

      // Update series
      setSeries([
        {
          name: "Total",
          data: totals, // same here
        },
      ]);

      setChartOptions((prev: any) => ({
        ...prev,
        tooltip: {
          shared: true, // Show tooltip for all series on hover
          intersect: false, // Show tooltip when hovering anywhere on x-axis category
          y: {
            formatter: function (val: number) {
              return val.toString(); // Show actual value, even if 0
            },
          },
        },
        yaxis: {
          min: 0,
          max: 20,
          tickAmount: 4,
          labels: {
            formatter: (val: number) => val.toFixed(0),
            style: {
              colors: "#6B7280",
              fontSize: "10px",
            },
          },
        },
        xaxis: {
          categories: categories,
        },
      }));
    } catch (error) {
      console.error("Error fetching lost lead reason:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getLostLeadReason("this_month");
  }, []);

  const handleFilterSelect = (label: string, e: React.MouseEvent) => {
    e.preventDefault();
    const apiValue = filterKeyMap[label];
    setSelectedFilter(label);
    getLostLeadReason(apiValue);
  };

  // Optional: initial load with default value
  useEffect(() => {
    getLostLeadReason("this_month");
    setSelectedFilter("This Month");
  }, []);

  // console.log("mmmmmmmmmmmmmmmmmmm", totalLead.leads_lost)

  const [selectedRange, setSelectedRange] = useState({
    start: moment().subtract(29, "days"),
    end: moment(),
  });

  // ✅ Called on date picker change
  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedRange({ start, end });
    // console.log('Selected Date Range:', start.format('YYYY-MM-DD'), 'to', end.format('YYYY-MM-DD'));
    getTotalLead(start, end);
  };

  const getTotalLead = async (
    startDate: moment.Moment,
    endDate: moment.Moment,
  ) => {
    try {
      setLoading(true);
      const payload = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
      };

      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.COUNT_LEAD_HISTORY,
        payload,
      );

      if (response && response.data !== undefined && response.data !== null) {
        setTotalLead(response?.data);
      } else {
        console.warn("API did not return expected data.");
        setTotalLead(0); // or null based on your application
      }
    } catch (error: any) {
      if (error.response) {
        // Server responded with a status code outside 2xx
        console.error(
          "API responded with an error:",
          error.response.status,
          error.response.data,
        );
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received from the API:", error.request);
      } else {
        // Some other error occurred
        console.error(
          "Unexpected error while fetching total leads:",
          error.message,
        );
      }

      // Set fallback or default value
      setTotalLead(0); // or null
    }
    setLoading(false);
  };

  useEffect(() => {
    getTotalLead(selectedRange.start, selectedRange.end);
  }, [selectedRange]);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 1 }, (_, i) => currentYear + i);
  // const years = [2025, 2026, 2027];

  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleYearSelect = (year: number, e: React.MouseEvent) => {
    e.preventDefault(); // prevent <a href="#"> scroll
    setSelectedYear(year);
    allPipeLine(year);
  };

  const allPipeLine = async (year: number | string) => {
    try {
      setLoading(true);
      const payload = {
        year: year.toString(), // ensures it's a string
      };

      // console.log(payload);

      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.PIPELINE_COUNT_LEADS_HISTORY,
        payload,
      );
      // console.log(response?.data, "yeaserswefasfasfasdf")
      setPipeLine(response?.data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    allPipeLine(selectedYear);
  }, []);

  const [recent, setRecent] = useState<any>([]);
  const [showAll, setShowAll] = useState(false);

  const visibleItems = showAll ? recent?.slice(0, 10) : recent?.slice(0, 5);

  const recentFollowTrail = async () => {
    setLoading(true);
    try {
      const payload = {
        limit: 10,
      };
      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.RECENT_FOLLOWUP_TRAILS,
        payload,
      );

      // Make sure it's an array, else set as empty array
      setRecent(Array.isArray(response?.data) ? response?.data : []);
    } catch (error) {
      console.log(error);
      setRecent([]); // Fallback in case of error
    }
    setLoading(false);
  };

  // const recentFollowTrail = async () => {
  //   setLoading(true)
  //   try {
  //     const payload = {
  //       "limit": 10
  //     }
  //     const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.RECENT_FOLLOWUP_TRAILS, payload)
  //     // console.log(response?.data, "bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb")
  //     setRecent(response?.data)
  //   } catch (error) {
  //     console.log(error)
  //   }
  //   setLoading(false)
  // }

  useEffect(() => {
    recentFollowTrail();
  }, []);

  type SourceItem = {
    source_type: string;
    total: number;
  };

  const [source, setSource] = useState<SourceItem[]>([]);
  const [selectedDuration, setSelectedDuration] = useState("this_month");
  const durationLabels: Record<string, string> = {
    this_month: "This Month",
    this_week: "This Week",
    last_week: "Last Week",
  };

  const handleDurationChange = (duration: any) => {
    // console.log("xxxxxx", duration)
    setSelectedDuration(duration);
    sourceTypeData(duration);
  };

  const sourceTypeData = async (duration: any) => {
    try {
      const payload = {
        filter: duration,
      };
      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.LEAD_SOURCE_COUNT,
        payload,
      );
      // console.log(response?.data, "Lead Source Response arjun new data");
      setSource(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  // 👇 Optionally fetch on mount for initial duration
  useEffect(() => {
    sourceTypeData(selectedDuration);
  }, []);

  // ***********************

  const [seriesData, setSeriesData] = useState<any[]>([
    { name: "Income", data: [] },
    { name: "month", data: [] },
  ]);

  const [revenueIncomeOptions, setRevenueIncomeOptions] = useState<any>({
    chart: {
      height: 230,
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    colors: ["#014d4e", "#F8F9FA"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 5,
        borderRadiusWhenStacked: "all",
        horizontal: false,
        endingShape: "rounded",
      },
    },
    xaxis: {
      categories: [], // Will be updated dynamically
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    yaxis: {
      tickAmount: 5,
      // tickAmount: 5,
      labels: {
        offsetX: -15,
        style: {
          colors: "#6B7280",
          fontSize: "12px",
        },
        formatter: function (value: number) {
          return value / 1000 + "k";
        },
      },
    },

    // yaxis: {
    //   min: 0,
    //   max: 100,
    //   labels: {
    //     formatter: function (value: string) {
    //       return value + "K";
    //     },
    //     style: {
    //       colors: '#6B7280',
    //       fontSize: '13px',
    //     }
    //   }
    // },
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
      // padding: {
      //   left: -8,
      // },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return val / 10 + " k";
        },
      },
    },
    fill: {
      opacity: 0,
    },
  });

  const fetchChartData = async () => {
    try {
      const payload = { year: selectedYear };
      const response = await AXIOSCONFIGMETHOD(
        "post",
        webServiceUrl.REVENUE_INCOME,
        payload,
      );
      const data = response?.data || [];
      // const data = [
      //   {
      //     month: "Mar",
      //     total_income: 0,
      //   },
      //   {
      //     month: "Apr",
      //     total_income: 4565,
      //   },
      //   {
      //     month: "Jun",
      //     total_income: 100,
      //   },
      // ];

      const incomeData = data.map((item: any) => item.total_income);
      const expenseData = data.map((item: any) => item.total_expense);
      const months = data.map((item: any) => item.month);

      console.log(incomeData);
      console.log(expenseData);
      console.log(months);

      setSeriesData([
        { name: "Income", data: incomeData },
        { name: "Expenses", data: expenseData },
      ]);

      // ✅ Only tooltip and xaxis updated — yaxis untouched
      setSeriesData([
        { name: "Income", data: incomeData },
        // { name: 'Expenses', data: expenseData }
      ]);

      setRevenueIncomeOptions((prev: any) => ({
        ...prev,
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (value: number) {
              return value / 1000 + "k";
            },
          },
        },
        fill: {
          opacity: 1, // 👈 make sure this is 1
        },
        xaxis: {
          ...prev.xaxis,
          categories: months,
        },
      }));
    } catch (error) {
      console.log("Error fetching chart data:", error);
    }
  };
  useEffect(() => {
    fetchChartData();
  }, [selectedYear]);

  // useEffect(() => {
  //   fetchChartData();
  // }, []);

  const [heat_chart] = useState<any>({
    chart: {
      type: "heatmap",
      height: 300,
    },
    colors: ["#9CA3AF", "#014d4e", "#9CA3AF", "#014d4e", "#9CA3AF", "#014d4e"],
    series: [
      {
        name: "0",
        data: [
          {
            x: "Mon",
            y: 22,
          },
          {
            x: "Tue",
            y: 29,
          },
          {
            x: "Wed",
            y: 13,
          },
          {
            x: "Thu",
            y: 32,
          },
          {
            x: "Fri",
            y: 32,
          },
          {
            x: "Sat",
            y: 32,
          },
          {
            x: "Sun",
            y: 32,
          },
        ],
      },
      {
        name: "20",
        data: [
          {
            x: "Mon",
            y: 22,
            color: "#ff5722",
          },
          {
            x: "Tue",
            y: 29,
          },
          {
            x: "Wed",
            y: 13,
          },
          {
            x: "Thu",
            y: 32,
          },
          {
            x: "Fri",
            y: 32,
          },
          {
            x: "Sat",
            y: 32,
          },
          {
            x: "Sun",
            y: 32,
          },
        ],
      },
      {
        name: "40",
        data: [
          {
            x: "Mon",
            y: 22,
          },
          {
            x: "Tue",
            y: 29,
          },
          {
            x: "Wed",
            y: 13,
          },
          {
            x: "Thu",
            y: 32,
          },
          {
            x: "Fri",
            y: 32,
          },
          {
            x: "Sat",
            y: 32,
          },
          {
            x: "Sun",
            y: 32,
          },
        ],
      },
      {
        name: "60",
        data: [
          {
            x: "Mon",
            y: 0,
          },
          {
            x: "Tue",
            y: 29,
          },
          {
            x: "Wed",
            y: 13,
          },
          {
            x: "Thu",
            y: 32,
          },
          {
            x: "Fri",
            y: 0,
          },
          {
            x: "Sat",
            y: 0,
          },
          {
            x: "Sun",
            y: 32,
          },
        ],
      },
      {
        name: "80",
        data: [
          {
            x: "Mon",
            y: 0,
          },
          {
            x: "Tue",
            y: 20,
          },
          {
            x: "Wed",
            y: 13,
          },
          {
            x: "Thu",
            y: 32,
          },
          {
            x: "Fri",
            y: 0,
          },
          {
            x: "Sat",
            y: 0,
          },
          {
            x: "Sun",
            y: 32,
          },
        ],
      },
      {
        name: "120",
        data: [
          {
            x: "Mon",
            y: 0,
          },
          {
            x: "Tue",
            y: 0,
          },
          {
            x: "Wed",
            y: 75,
          },
          {
            x: "Thu",
            y: 0,
          },
          {
            x: "Fri",
            y: 0,
          },
          {
            x: "Sat",
            y: 0,
          },
          {
            x: "Sun",
            y: 0,
          },
        ],
      },
    ],
  });

  // const [leads_stage] = useState<any>({

  //   chart: {
  //     height: 355,
  //     type: 'bar',
  //     stacked: true,
  //     toolbar: {
  //       show: false,
  //     }
  //   },
  //   // colors: ['#FF6F28', '#F8F9FA'],
  //   colors: ['#014d4e', '#F8F9FA'],
  //   responsive: [{
  //     breakpoint: 480,
  //     options: {
  //       legend: {
  //         position: 'bottom',
  //         offsetX: -10,
  //         offsetY: 0
  //       }
  //     }
  //   }],
  //   plotOptions: {
  //     bar: {
  //       borderRadius: 5,
  //       borderRadiusWhenStacked: 'all',
  //       horizontal: false,
  //       endingShape: 'rounded'
  //     },
  //   },
  //   series: [{
  //     name: 'Deal Lost',
  //     data: [80, 40, 60, 40]
  //   }, {
  //     name: 'Expenses',
  //     data: [100, 100, 100, 100]
  //   }],
  //   xaxis: {
  //     categories: ['Competitor', 'Budget', 'Unresponsie', 'Timing'],
  //     // categories: lostLeadReason,
  //     labels: {
  //       style: {
  //         colors: '#6B7280',
  //         fontSize: '9px',
  //       }
  //     }
  //   },
  //   yaxis: {
  //     labels: {
  //       offsetX: -15,
  //       style: {
  //         colors: '#6B7280',
  //         fontSize: '10px',
  //       }
  //     }
  //   },
  //   grid: {
  //     borderColor: '#E5E7EB',
  //     strokeDashArray: 5
  //   },
  //   legend: {
  //     show: false
  //   },
  //   dataLabels: {
  //     enabled: false // Disable data labels
  //   },
  //   fill: {
  //     opacity: 1
  //   },
  // });

  // chart data pie chart**************************************
  const colorPalette = [
    "#FF6384", // red
    "#36A2EB", // blue
    "#FFCE56", // yellow
    "#4BC0C0", // teal
    "#9966FF", // purple
    "#FF9F40", // orange
    "#8BC34A", // green
    "#00ACC1", // cyan
    "#D84315", // deep orange
    "#7B1FA2", // deep purple
  ];

  // 👇 Create a color map based on source dynamically
  const sourceColorMap: Record<string, string> = {};
  source.forEach((item, index) => {
    const label = item.source_type;
    if (!sourceColorMap[label]) {
      sourceColorMap[label] = colorPalette[index % colorPalette.length];
    }
  });

  const [donutchart2] = useState<any>({
    series: [25, 30, 10, 35],
    chart: {
      type: "donut",
      height: 185,
    },
    labels: ["Paid", "Google", "Referals", "Campaigns"], // Labels for the data  0C4B5E
    colors: ["#FFC107", "#0C4B5E", "#AB47BC", "#FD3995"], // Colors from the image
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
          labels: {
            show: true,
            // total: {
            //   show: true,
            //   label: 'Google',
            //   formatter: function (w: any) {
            //     return '40%';
            //   }
            // }
          },
        },
      },
    },
    stroke: {
      lineCap: "round",
      show: true,
      width: 0,
      colors: "#fff",
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    label: {
      show: false,
    },
  });

  // Safely map over typed array
  const labels = source.map((item) => item.source_type);
  const dataValues = source.map((item) => item.total);

  const backgroundColors = labels.map((label) => sourceColorMap[label]);

  const data = {
    labels,
    datasets: [
      {
        data: dataValues,
        backgroundColor: backgroundColors,
        borderWidth: 1,
      },
    ],
  };

  const options: any = {
    cutout: "60%",
    plugins: {
      legend: {
        display: false, // No legend
      },
      tooltip: {
        enabled: true, // No tooltip
      },
      title: {
        display: true,
        // text: 'Lead Sources\nThis Month',
        font: {
          size: 15,
        },
        padding: {
          bottom: 1,
        },
      },
    },
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Leads Dashboard</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leads Dashboard
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {/* <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as PDF
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
              {/* <div className="input-icon mb-2 position-relative">
                <PredefinedDateRanges />
              </div> */}
              <div className="input-icon mb-2 position-relative">
                <PredefinedDateRanges onDateChange={handleDateChange} />
              </div>

              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          <div className="custom-grid mb-2">
            {/* Total Leads */}
            <div className="card position-relative mb-2">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="avatar avatar-md br-10 icon-rotate flex-shrink-0"
                    style={{ backgroundColor: "#6b7280" }}
                  >
                    <span className="d-flex align-items-center">
                      <i className="ti ti-delta text-white fs-16" />
                    </span>
                  </div>
                  <div className="ms-3">
                    <p className="fw-medium text-truncate mb-1">Total Leads</p>
                    <h5>{totalLead.total_leads}</h5>
                  </div>
                </div>
                <div className="progress progress-xs mb-2">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      backgroundColor: "#6b7280",
                      width: `${totalLead.total_leads ? 100 : 0}%`,
                    }}
                  />
                </div>
                <span className="position-absolute top-0 end-0">
                  <ImageWithBasePath
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                  />
                </span>
              </div>
            </div>

            {/* Leads Won */}
            <div className="card position-relative mb-2">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="avatar avatar-md br-10 icon-rotate flex-shrink-0"
                    style={{ backgroundColor: "#014d4e" }}
                  >
                    <span className="d-flex align-items-center">
                      <i className="ti ti-currency text-white fs-16" />
                    </span>
                  </div>
                  <div className="ms-3">
                    <p className="fw-medium text-truncate mb-1">Leads Won</p>
                    <h5>{totalLead.leads_won}</h5>
                  </div>
                </div>
                <div className="progress progress-xs mb-2">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      backgroundColor: "#014d4e",
                      width: `${
                        totalLead.total_leads
                          ? Math.round(
                              (totalLead.leads_won / totalLead.total_leads) *
                                100,
                            )
                          : 0
                      }%`,
                    }}
                  />
                </div>
                <span className="position-absolute top-0 end-0">
                  <ImageWithBasePath
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                  />
                </span>
              </div>
            </div>

            {/* Leads Lost */}
            <div className="card position-relative mb-2">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="avatar avatar-md br-10 icon-rotate flex-shrink-0"
                    style={{ backgroundColor: "#6b7280" }} // red shade for lost
                  >
                    <span className="d-flex align-items-center">
                      <i className="ti ti-stairs-up text-white fs-16" />
                    </span>
                  </div>
                  <div className="ms-3">
                    <p className="fw-medium text-truncate mb-1">Leads Lost</p>
                    <h5>{totalLead.leads_lost}</h5>
                  </div>
                </div>
                <div className="progress progress-xs mb-2">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      backgroundColor: "#6b7280",
                      width: `${
                        totalLead.total_leads
                          ? Math.round(
                              (totalLead.leads_lost / totalLead.total_leads) *
                                100,
                            )
                          : 0
                      }%`,
                    }}
                  />
                </div>
                <span className="position-absolute top-0 end-0">
                  <ImageWithBasePath
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                  />
                </span>
              </div>
            </div>

            {/* Open Leads */}
            <div className="card position-relative mb-2">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="avatar avatar-md br-10 icon-rotate flex-shrink-0"
                    style={{ backgroundColor: "#014d4e" }}
                  >
                    <span className="d-flex align-items-center">
                      <i className="ti ti-users-group text-white fs-16" />
                    </span>
                  </div>
                  <div className="ms-3">
                    <p className="fw-medium text-truncate mb-1">Open Leads</p>
                    <h5>{totalLead.open_leads_till_date}</h5>
                  </div>
                </div>
                <div className="progress progress-xs mb-2">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      backgroundColor: "#014d4e",
                      width: `${
                        totalLead.total_leads
                          ? Math.round(
                              (totalLead.open_leads_till_date /
                                totalLead.total_leads) *
                                100,
                            )
                          : 0
                      }%`,
                    }}
                  />
                </div>
                <span className="position-absolute top-0 end-0">
                  <ImageWithBasePath
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                  />
                </span>
              </div>
            </div>

            {/* Assigned Leads */}
            <div className="card position-relative mb-2">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="avatar avatar-md br-10 icon-rotate flex-shrink-0"
                    style={{ backgroundColor: "#6b7280" }}
                  >
                    <span className="d-flex align-items-center">
                      <i className="ti ti-users-group text-white fs-16" />
                    </span>
                  </div>
                  <div className="ms-3">
                    <p className="fw-medium text-truncate mb-1">
                      Assigned Leads
                    </p>
                    <h5>{totalLead.assigned_till_date}</h5>
                  </div>
                </div>
                <div className="progress progress-xs mb-2">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      backgroundColor: "#6b7280",
                      width: `${
                        totalLead.total_leads
                          ? Math.round(
                              (totalLead.assigned_till_date /
                                totalLead.total_leads) *
                                100,
                            )
                          : 0
                      }%`,
                    }}
                  />
                </div>
                <span className="position-absolute top-0 end-0">
                  <ImageWithBasePath
                    src="assets/img/bg/card-bg-04.png"
                    alt="Img"
                  />
                </span>
              </div>
            </div>
          </div>

          <div className="row">
            {/* pipeline start code  */}
            <div className="col-xl-8 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Pipeline Stages</h5>

                    <div className="dropdown">
                      <a
                        href="#"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i className="ti ti-calendar me-1" />
                        {selectedYear}
                      </a>

                      <ul className="dropdown-menu dropdown-menu-end p-3">
                        {years?.map((year) => (
                          <li key={year}>
                            <a
                              href="#"
                              className="dropdown-item rounded-1"
                              onClick={(e) => handleYearSelect(year, e)}
                            >
                              {year}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <Loader />
                ) : (
                  <div className="card-body pb-0">
                    <div className="row g-2 justify-content-center mb-3">
                      <div className="col-md col-sm-4 col-6">
                        <div className="border rounded p-2">
                          <p className="mb-1">
                            <i className="ti ti-point-filled text-primary" />
                            Assigned
                          </p>
                          <h6>{pipeLine.Assigned}</h6>
                        </div>
                      </div>
                      <div className="col-md col-sm-4 col-6">
                        <div className="border rounded p-2">
                          <p className="mb-1">
                            <i className="ti ti-point-filled text-primary" />
                            Followup
                          </p>
                          <h6>{pipeLine.Followup}</h6>
                        </div>
                      </div>
                      <div className="col-md col-sm-4 col-6">
                        <div className="border rounded p-2">
                          <p className="mb-1">
                            <i className="ti ti-point-filled text-primary" />
                            Missed
                          </p>
                          <h6>{pipeLine.Missed}</h6>
                        </div>
                      </div>
                      <div className="col-md col-sm-4 col-6">
                        <div className="border rounded p-2">
                          <p className="mb-1">
                            <i className="ti ti-point-filled text-primary" />
                            Won
                          </p>
                          <h6>{pipeLine.Won}</h6>
                        </div>
                      </div>
                      <div className="col-md col-sm-4 col-6">
                        <div className="border rounded p-2">
                          <p className="mb-1">
                            <i className="ti ti-point-filled text-primary" />
                            Lost
                          </p>
                          <h6>{pipeLine.Lost}</h6>
                        </div>
                      </div>
                    </div>
                    <ReactApexChart
                      id="revenue-income"
                      options={revenueIncomeOptions}
                      series={seriesData}
                      type="bar"
                      height={230}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* Leads Source */}
            <div className="col-xl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Leads Source</h5>

                    <div className="dropdown">
                      <Link
                        onClick={(e) => e.preventDefault()}
                        to="#"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i className="ti ti-calendar me-1" />
                        {durationLabels[selectedDuration] || "Select Duration"}
                      </Link>

                      <ul className="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <Link
                            onClick={() => handleDurationChange("this_month")}
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            This Month
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={() => handleDurationChange("this_week")}
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            This Week
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={() => handleDurationChange("last_week")}
                            to="#"
                            className="dropdown-item rounded-1"
                          >
                            Last Week
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  className="card-body"
                  style={{
                    height: "400px", // scrollable height
                    overflowY: "auto",
                  }}
                >
                  <div style={{ width: 200, margin: "auto" }}>
                    {source.length === 0 && (
                      <div
                        className="text-muted"
                        style={{
                          color: "black",
                          textAlign: "center",
                          marginBottom: 10,
                          marginTop: 20,
                        }}
                      >
                        Data not found
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <Doughnut data={data} options={options} />
                    )}
                  </div>

                  <div className="ps-3 pe-3 mt-4">
                    {/* <h6 className="mb-3 ps-3">Status</h6> */}
                    {source.map((item, index) => (
                      <div
                        key={index}
                        className="d-flex p-0 align-items-center justify-content-between mb-2 mt-3"
                      >
                        <p className="f-13 mb-0">
                          <i
                            className="ti ti-circle-filled me-1"
                            style={{ color: sourceColorMap[item.source_type] }}
                          />
                          {item.source_type}
                        </p>
                        <p className="f-13 fw-medium">{item.total}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* Lost Leads By Reason */}
            <div className="col-xl-8 d-flex">
              <div className="card flex-fill ">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Lost Leads By Reason</h5>

                    <div className="dropdown">
                      <a
                        href="#"
                        className="btn btn-white border-0 dropdown-toggle btn-sm d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {selectedFilter}
                      </a>

                      <ul className="dropdown-menu dropdown-menu-end p-3">
                        {["This Month", "This Week", "Last Week"].map(
                          (label) => (
                            <li key={label}>
                              <a
                                href="#"
                                className="dropdown-item rounded-1"
                                onClick={(e) => handleFilterSelect(label, e)}
                              >
                                {label}
                              </a>
                            </li>
                          ),
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <Loader />
                ) : (
                  <div className="card-body py-0">
                    <ReactApexChart
                      options={chartOptions}
                      series={series}
                      type="bar"
                      height={300}
                    />
                  </div>
                )}
              </div>
              <style>
                {`
                .col-xl-4.d-flex {
                  align-items: flex-start;
                }

                .card.fixed-height {
                  height: 100%;
                  min-height: 400px;
                }

                `}
              </style>
            </div>
            <div className="col-xl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Recent Follow Up</h5>
                  </div>
                </div>

                {loading ? (
                  <Loader />
                ) : recent && recent.length > 0 ? (
                  <div
                    className="card-body"
                    style={{
                      height: "410px", // scrollable height
                      overflowY: "auto",
                    }}
                  >
                    {recent?.map((item: any, index: number) => (
                      <div
                        key={index}
                        className={`d-flex align-items-center justify-content-between ${
                          index !== recent.length - 1 ? "mb-4" : ""
                        }`}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ms-2">
                            <h6 className="fs-14 fw-medium text-truncate mb-1">
                              <Link to="#">{item.lead_name}</Link>
                            </h6>
                            <p className="fs-13 mb-0">
                              {item?.followup_comments ?? item?.email_id ?? ""}
                            </p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center">
                          <span
                            className="bg-light px-2 py-1"
                            style={{
                              color:
                                item.lead_stage === "LOST"
                                  ? "red"
                                  : item.lead_stage === "WON"
                                    ? "green"
                                    : item.lead_stage === "FOLLOWUP"
                                      ? "orange"
                                      : "black",
                            }}
                          >
                            {item.lead_stage}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="card-body text-center text-muted py-4">
                    Data not found
                  </div>
                )}
              </div>
            </div>
          </div>

          <style>
            {`
.col-xl-4.d-flex {
  align-items: flex-start;
}

.card.fixed-height {
  height: 100%;
  min-height: 400px;
}

`}
          </style>

          {/* Recent Follow Up */}
          {/* <div className="row d-flex align-items-stretch">
          
          
          </div> */}

          {/* Source Type end  */}

          {/* ================================= */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0 text-center">
            © {new Date().getFullYear()} Nestfin Technology. All rights
            reserved.
          </p>
          {/* <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              Bizclockarts
            </Link>
          </p> */}
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default LeadsDasboard;
